__turbopack_context__.v({
  "innerWrapper": "NetworkStatus-module__Jh8XFW__innerWrapper",
  "root": "NetworkStatus-module__Jh8XFW__root",
  "subscribeNetwork": "NetworkStatus-module__Jh8XFW__subscribeNetwork",
});
